import {OutlinedInput} from '@material-ui/core'
import FormControl from '@material-ui/core/FormControl'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import SearchBar from 'components/Forms/SearchBar'

import useToolbarStyles, {
  useOutlinedInputStyles,
} from 'components/Table/useTableToolbarStyles'
import useProductManagement from 'features/productManagement/useProductManagement'
import {getQueryFromUrl} from 'helpers/commonHelper'
import React, {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {useLocation} from 'react-router-dom'

const SEARCH_SELECT_ITEMS = [
  {label: 'IProductNameSelect', value: 'goodsName'},
  {label: 'IOrderNumber', value: 'paymentNo'},
]

interface SelectAnalysisSearchProps {
  onSearch: (params: {searchName: string; searchValue: string}) => void
}

export default function ToolbarSearch({onSearch}: SelectAnalysisSearchProps) {
  const location = useLocation()
  const classes = useToolbarStyles()
  const outlinedInputClasses = useOutlinedInputStyles()
  const {handleGetProductPurchaseHistory} = useProductManagement()

  const {t} = useTranslation()

  const [searchCondition, setSearchCondition] = useState(
    SEARCH_SELECT_ITEMS[0].value,
  )
  const [searchKeyword, setSearchKeyword] = useState('')

  const handleSearchChanged = (event: React.ChangeEvent<{value: unknown}>) =>
    setSearchCondition(event.target.value as KeyOfEdfSearchKind)

  const handleSearch = () => {
    const searchParams = getQueryFromUrl(location.search)
    SEARCH_SELECT_ITEMS.forEach((item) => {
      if (item.value in searchParams) {
        delete searchParams[item.value]
      }
    })

    handleGetProductPurchaseHistory({
      ...searchParams,
      ...(searchKeyword.length > 0 && {[searchCondition]: searchKeyword}),
    })
  }

  const handleValue = (value: any) => {
    setSearchKeyword(value)
  }

  useEffect(() => {
    const searchParams = getQueryFromUrl(location.search)
    SEARCH_SELECT_ITEMS.forEach((item) => {
      if (item.value in searchParams) {
        setSearchCondition(item.value)
        setSearchKeyword(searchParams[item.value])
      }
    })
  }, [])

  return (
    <div className={classes.container}>
      <FormControl variant='outlined'>
        <Select
          value={searchCondition}
          onChange={handleSearchChanged}
          className={classes.searchSelect}
          input={
            <OutlinedInput
              name='age'
              id='outlined-age-simple'
              classes={outlinedInputClasses}
            />
          }
        >
          {SEARCH_SELECT_ITEMS.map((item) => (
            <MenuItem value={item.value} key={item.value}>
              {t(item.label)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <SearchBar
        onChangeValue={handleValue}
        onSearchEvent={handleSearch}
        disabledValue={false}
      />
    </div>
  )
}
